var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddLawyer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3751 16H2.37502C1.84458 16 1.33587 16.2107 0.960791 16.5858C0.585715 16.9609 0.375 17.4696 0.375 18C0.375 18.5305 0.585715 19.0392 0.960791 19.4142C1.33587 19.7893 1.84458 20 2.37502 20H18.3751C18.9056 20 19.4143 19.7893 19.7894 19.4142C20.1644 19.0392 20.3752 18.5305 20.3752 18C20.3752 17.4696 20.1644 16.9609 19.7894 16.5858C19.4143 16.2107 18.9056 16 18.3751 16Z",
    fill: "#3751FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37503 8.6665H2.375V14.6666H6.37503V8.6665Z",
    fill: "#3751FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9325 3.37187L10.5991 0.0385137C10.4542 -0.0128379 10.296 -0.0128379 10.1511 0.0385137L0.81767 3.37187C0.68811 3.41809 0.576018 3.50326 0.496766 3.61569C0.417514 3.72812 0.374981 3.86232 0.375 3.99988V6.66656C0.375 6.84338 0.445238 7.01295 0.570264 7.13797C0.695289 7.263 0.864859 7.33324 1.04167 7.33324H19.7085C19.8853 7.33324 20.0549 7.263 20.1799 7.13797C20.3049 7.01295 20.3752 6.84338 20.3752 6.66656V3.99988C20.3752 3.86232 20.3326 3.72812 20.2534 3.61569C20.1741 3.50326 20.062 3.41809 19.9325 3.37187Z",
    fill: "#3751FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3752 8.6665H8.37512V14.6666H12.3752V8.6665Z",
    fill: "#3751FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3752 8.6665H14.3751V14.6666H18.3752V8.6665Z",
    fill: "#3751FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddLawyer);
export default __webpack_public_path__ + "static/media/add_lawyer.cfa5839980b6623b85440bf2cd619c45.svg";
export { ForwardRef as ReactComponent };